import type { OptionProps } from '~/types/component'
import type { BranchData, CounterData } from '~/types/counter'

const transformBranches = ({ data }: { data: BranchData[] }) =>
  data
    .map(({ location_id: value, location_name: label }) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label))

const transformNeeds = ({ data }: { data: CounterData[] }) => {
  // Preserve admin-configured order (mst_counter_necessary.order) from counter edit.
  // Deduplicate across loket in the same cabang: keep the smallest order seen.
  const byId = new Map<string, OptionProps & { order: number }>()

  data.forEach(({ necessary }) => {
    necessary.forEach(({ necessary_id: value, necessary_name: label, pivot }) => {
      const order = typeof pivot?.order === 'number' ? pivot.order : Number.MAX_SAFE_INTEGER
      const existing = byId.get(value)
      if (!existing || order < existing.order) {
        byId.set(value, { value, label, order })
      }
    })
  })

  return Array.from(byId.values())
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label))
    .map(({ value, label }) => ({ value, label }))
}

const transformCounters = ({ data }: { data: CounterData[] }) =>
  data
    .map(({ counter_id: value, counter_name: label }) => ({ value, label }))
    .sort((a, b) => a.label.localeCompare(b.label))

const generateNumberOptions = (start: number, end: number): OptionProps[] => {
  const options: OptionProps[] = Array.from({ length: end - start + 1 }, (_, index) => ({
    value: start + index,
    label: (start + index).toString(),
  }))

  return options
}

export { generateNumberOptions, transformBranches, transformCounters, transformNeeds }
